import React from "react";

import { useQueryGetClassroomCourseCalendar } from "@examspark/common-app";
import { Loading } from "@examspark/common-ui";
import { Classroom } from "@examspark/types";

import SetupPrompt from "../common/SetupPrompt";

import ClassroomPlannerYag from "./planners/ClassroomPlannerYag";

const ClassroomPlanner = (props: { classroom: Classroom }) => {
  const courseCalendarQuery = useQueryGetClassroomCourseCalendar(
    props.classroom,
  );
  if (!courseCalendarQuery.isFetched) return <Loading />;

  if (!courseCalendarQuery.data) {
    return (
      <SetupPrompt>
        <SetupPrompt.Title>No Calendar Selected</SetupPrompt.Title>
        <SetupPrompt.Text>
          Please select a calendar in Classroom Settings.
        </SetupPrompt.Text>
      </SetupPrompt>
    );
  }

  // this should not happen
  if (!props.classroom.course) {
    return null;
  }

  return (
    <ClassroomPlannerYag
      course={props.classroom.course}
      value={{
        type: "CourseCalendar",
        value: courseCalendarQuery.data,
      }}
      linkContext={{
        type: "classroom",
        classroom: props.classroom,
      }}
      {...props}
    />
  );
};

export default ClassroomPlanner;
